import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'project-report-button-header',
    template: require('./project.report-button-header.component.html'),
})
export class ProjectReportButtonHeader {

    @Output() refreshData = new EventEmitter<void>();
    @Output() downloadData = new EventEmitter<string>();

    // user => profile
    @Input() loading: boolean = true;
}
